import { render, staticRenderFns } from "./TgCjList.vue?vue&type=template&id=5f1a3242&"
import script from "./TgCjList.vue?vue&type=script&lang=js&"
export * from "./TgCjList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports